import React, { useEffect, useState } from "react";
import { useData } from "../../../context/DataContext";
import { Link } from "react-router-dom";
import TodoPreviewCard from '../../editData/TodoEditor';
import NoteCardPreviewCard from '../../editData/NoteCardEditor';
import DrawingPreviewCard from '../../editData/Drawing';
import ImagePreviewCard from '../../editData/ImageCard';
import { IoClose, IoCloseSharp } from "react-icons/io5";
import { FaCompressAlt, FaEdit, FaFilter, FaSearch } from "react-icons/fa";
import { generateHTML, getUniqueColors, ParseDate } from "../../../../common/methods";
// import { MdOutlinePlayCircleFilled } from "react-icons/md";
import * as Popover from "@radix-ui/react-popover";
import { BsThreeDotsVertical } from "react-icons/bs";
import Card from "../card/Card";
import { addDoc, collection, deleteDoc, doc, getDocs, query, updateDoc, where } from "firebase/firestore";
import * as AlertDialog from "@radix-ui/react-alert-dialog";
import { PiEmptyBold } from "react-icons/pi";
import toast, { Toaster } from "react-hot-toast";
import { db } from "../../../../config/firebase";
import { useUserAuth } from "../../../context/UserAuthContext";



function Search() {
  const { user } = useUserAuth();
  const { setboardPreview, boardPreview, setTitle, setTrashCards, cards, setCards, CardsLoading } = useData();
  const [results, setResults] = useState(cards);
  const [isBoardEditing, setisBoardEditing] = useState(false);
  const [Input, setInput] = useState("");
  const [Color, setColor] = useState('');
  const [Type, setType] = useState('');
  const [newCardName, setNewCardName] = useState("");
  const [Share, setShare] = useState({});
  const [isRenameOpen, setisRenameOpen] = useState(false);
  const [isRenaming, setisRenaming] = useState(false);
  const [isDeleteOpen, setisDeleteOpen] = useState(false);
  const [isDeleting, setisDeleting] = useState(false);
  const [isShareOpen, setisShareOpen] = useState(false);
  const [isEditing, setisEditing] = useState(false);
  const [isSharing, setisSharing] = useState(false);

  const availableColors = getUniqueColors(cards);

  const availableTypes = [
    {
      name: 'note',
      svg: '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M7 17V9.93L13.93 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8.93L14.07 17H7z"></path><path d="M9 15h4.24l7.2-7.2-4.24-4.24-7.2 7.2zM22.91 2.49 21.5 1.08c-.78-.78-2.05-.78-2.83 0l-1.06 1.06 4.24 4.24 1.06-1.06c.79-.78.79-2.05 0-2.83z"></path></svg>'
    },
    {
      name: 'todo',
      svg: '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"></path></svg>'
    },
    {
      name: 'sketch',
      svg: '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M10.0357 7.69802C8.38492 9.55932 6.5134 12.2442 4.89465 15.4817C4.64766 15.9757 4.04698 16.1759 3.55301 15.9289C3.05903 15.6819 2.8588 15.0812 3.10579 14.5873C4.79739 11.2041 6.76494 8.37171 8.53943 6.37095C9.4251 5.37234 10.2797 4.56162 11.0449 3.99131C11.4272 3.7063 11.8049 3.46806 12.1677 3.29756C12.5193 3.13234 12.921 3 13.3336 3C13.5496 3 13.7872 3.0535 14.007 3.19476C14.2233 3.33371 14.3629 3.51925 14.4495 3.69083C14.6066 4.00215 14.624 4.33473 14.6201 4.55938C14.6118 5.03651 14.4847 5.6328 14.3216 6.23975C13.9874 7.48318 13.3994 9.13104 12.8149 10.7577L12.7329 10.9858C12.1671 12.5598 11.6101 14.1093 11.248 15.3466C11.1505 15.68 11.0706 15.9792 11.0094 16.2414C11.7035 15.6835 12.5581 14.8454 13.466 13.9534L13.4956 13.9243C14.3772 13.0581 15.3098 12.1418 16.0967 11.5127C16.4872 11.2006 16.9082 10.904 17.3138 10.7322C17.6544 10.5878 18.4343 10.3532 19.0407 10.9596C19.4251 11.344 19.5318 11.8438 19.5594 12.2164C19.5883 12.6064 19.5429 13.0267 19.4725 13.4261C19.3315 14.2258 19.0483 15.159 18.7894 16.0009L18.7478 16.136C18.5165 16.8874 18.3102 17.5577 18.1926 18.0965C18.4529 17.8352 18.7734 17.4216 19.1475 16.811C19.436 16.34 20.0517 16.1921 20.5226 16.4806C20.9935 16.7691 21.1414 17.3848 20.8529 17.8557C20.3099 18.7422 19.748 19.4622 19.1519 19.9092C18.5283 20.377 17.7121 20.6407 16.8863 20.2278C16.2779 19.9235 16.1398 19.3173 16.1091 18.9819C16.0759 18.6192 16.1284 18.2233 16.1979 17.8667C16.3288 17.1944 16.5829 16.3698 16.823 15.5907L16.8777 15.4129C17.1447 14.5451 17.3873 13.734 17.5028 13.0789C17.5117 13.0284 17.5196 12.9802 17.5266 12.9341C17.4697 12.977 17.4094 13.0239 17.3455 13.0749C16.6477 13.6328 15.785 14.4788 14.8677 15.38L14.8381 15.4091C13.9566 16.2752 13.024 17.1915 12.2371 17.8206C11.8466 18.1328 11.4255 18.4293 11.02 18.6012C10.6794 18.7455 9.89947 18.9801 9.29311 18.3738C8.9843 18.065 8.9052 17.6753 8.87972 17.4382C8.8515 17.1755 8.86901 16.8971 8.90269 16.6351C8.9706 16.1069 9.12934 15.4656 9.32855 14.7849C9.70829 13.4872 10.2842 11.8852 10.8411 10.3362L10.9327 10.0814C11.5263 8.42931 12.082 6.8674 12.3901 5.72074C12.4172 5.61968 12.4418 5.52435 12.4638 5.43468C12.3924 5.48361 12.3178 5.53695 12.2401 5.59489C11.6173 6.05907 10.8627 6.76559 10.0357 7.69802Z"></path></svg>'
    },
    {
      name: 'image',
      svg: '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"></path></svg>'
    },
    {
      name: 'audio',
      svg: '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z"></path></svg>'
    }
  ];

  useEffect(() => {
    setTitle("Search for Cards");
    setboardPreview({})

    return () => {
      setboardPreview({})
      setTitle("");
    };
  }, []);

  useEffect(() => {
    handleSearch();
  }, [Input, Color, Type])

  const handleSearch = () => {
    if (!Type && !Color) {
      setResults(
        cards.filter((card) =>
          card.name.toLowerCase().includes(Input.toLowerCase())
        )
      );
    }
    else if (Type && Color) {
      setResults(
        cards.filter((card) =>
          card.name.toLowerCase().includes(Input.toLowerCase()) && card.type == Type && card.color == Color
        )
      );
    }
    else if (Type) {
      setResults(
        cards.filter((card) =>
          card.name.toLowerCase().includes(Input.toLowerCase()) && card.type == Type
        )
      );
    }
    else if (Color) {
      setResults(
        cards.filter((card) =>
          card.name.toLowerCase().includes(Input.toLowerCase()) && card.color == Color
        )
      );
    }
    else {
      setResults(
        cards.filter((card) =>
          card.name.toLowerCase().includes(Input.toLowerCase())
        )
      );
    }
  }

  const isNotEmptyObject = (obj) => Object.keys(obj).length > 0;

  const handleCardRename = async (card) => {
    if (newCardName.length > 0 && newCardName !== card.name) {
      try {
        setisRenaming(true);
        const userDocQuery = query(
          collection(db, "notecard"),
          where("ncid", "==", card.ncid)
        );

        const querySnapshot = await getDocs(userDocQuery);

        if (!querySnapshot.empty) {
          const docRef = querySnapshot.docs[0].ref;
          const updatedTime = new Date();

          await updateDoc(docRef, {
            name: newCardName,
            updatedAt: updatedTime,
          });

          setCards((prevCards) => {
            const updatedCards = prevCards.map((c) =>
              c.ncid === card.ncid
                ? { ...c, name: newCardName, updatedAt: updatedTime }
                : c
            );

            return updatedCards.sort((a, b) => {
              const dateA = a.updatedAt?.toDate ? a.updatedAt.toDate() : a.updatedAt;
              const dateB = b.updatedAt?.toDate ? b.updatedAt.toDate() : b.updatedAt;

              return dateB - dateA;
            });
          });

          setResults((prevCards) => {
            const updatedCards = prevCards.map((c) =>
              c.ncid === card.ncid
                ? { ...c, name: newCardName, updatedAt: updatedTime }
                : c
            );

            return updatedCards.sort((a, b) => {
              const dateA = a.updatedAt?.toDate ? a.updatedAt.toDate() : a.updatedAt;
              const dateB = b.updatedAt?.toDate ? b.updatedAt.toDate() : b.updatedAt;

              return dateB - dateA;
            });
          });

          setboardPreview({});
          setNewCardName("");
          setisRenameOpen(false);
          toast.success("Renamed Successfully")
        } else {
          console.log("No matching document found.");
        }
      } catch (error) {
        console.error("Error renaming card:", error);
        setisRenameOpen(true);
      }
      finally {
        setisRenaming(false);
      }
    }
  };

  const SortData = () => {
    setCards(cards => cards.sort((a, b) => {
      const dateA = a.updatedAt?.toDate ? a.updatedAt.toDate() : a.updatedAt;
      const dateB = b.updatedAt?.toDate ? b.updatedAt.toDate() : b.updatedAt;

      return dateB - dateA;
    }));
    setResults(cards => cards.sort((a, b) => {
      const dateA = a.updatedAt?.toDate ? a.updatedAt.toDate() : a.updatedAt;
      const dateB = b.updatedAt?.toDate ? b.updatedAt.toDate() : b.updatedAt;

      return dateB - dateA;
    }))
  }

  const HandleShare = async (e) => {
    e.preventDefault();

    if (Share.email !== user.email) {
      try {
        const card = Share.obj;
        setisSharing(true);

        const userDocQuery = query(
          collection(db, "notecard"),
          where("ncid", "==", card.ncid)
        );

        const querySnapshot = await getDocs(userDocQuery);

        if (!querySnapshot.empty) {
          const docRef = querySnapshot.docs[0].ref;

          if (!card.shared.includes(Share.email)) {
            const updatedArray = [...card.shared, Share.email];

            await updateDoc(docRef, {
              shared: updatedArray,
            });

            setCards((prevCards) => {
              const updatedCards = prevCards.map((c) =>
                c.ncid === card.ncid
                  ? {
                    ...c,
                    shared: updatedArray,
                  }
                  : c
              );

              return updatedCards.sort((a, b) => {
                const dateA = a.updatedAt?.toDate
                  ? a.updatedAt.toDate()
                  : a.updatedAt;
                const dateB = b.updatedAt?.toDate
                  ? b.updatedAt.toDate()
                  : b.updatedAt;

                return dateB - dateA;
              });
            });

            setResults((prevCards) => {
              const updatedCards = prevCards.map((c) =>
                c.ncid === card.ncid
                  ? {
                    ...c,
                    shared: updatedArray,
                  }
                  : c
              );

              return updatedCards.sort((a, b) => {
                const dateA = a.updatedAt?.toDate
                  ? a.updatedAt.toDate()
                  : a.updatedAt;
                const dateB = b.updatedAt?.toDate
                  ? b.updatedAt.toDate()
                  : b.updatedAt;

                return dateB - dateA;
              });
            });
          } else {
            toast.error(`${card.type[0].toUpperCase() + card.type.slice(1)} Card is already Shared to ${Share.email}`);
          }

          setboardPreview({});
          setShare({});
          setisShareOpen(false);
          toast.success(`${card.type[0].toUpperCase() + card.type.slice(1)} Card is Shared successfully`)
        } else {
          console.log("No matching document found.");
        }
      } catch (error) {
        console.error("Error sharing card:", error);
      } finally {
        setisSharing(false);
      }
    } else {
      toast.error("Can't share with the same email address");
    }
  };

  const HandleDelete = async (card) => {
    try {
      setisDeleting(true);
      const updatedCard = { ...card, updatedAt: new Date() };

      // Query to find the document reference
      const cardQuery = query(
        collection(db, "notecard"),
        where("ncid", "==", card.ncid)
      );
      const querySnapshot = await getDocs(cardQuery);

      if (!querySnapshot.empty) {
        const docRef = querySnapshot.docs[0].ref;
        await addDoc(collection(db, "notecardtrash"), updatedCard);
        await deleteDoc(docRef);
        setCards((prevCards) => prevCards.filter((ele) => ele.ncid !== card.ncid));
        setResults((prevResults) => prevResults.filter((ele) => ele.ncid !== card.ncid));
        setTrashCards((prevTrash) => [updatedCard, ...prevTrash]);
        setboardPreview({});
        setisDeleteOpen(false);
      } else {
        console.error("Error: Card not found.");
      }
    } catch (error) {
      console.error("Error deleting card:", error);
    }
    finally {
      setisDeleting(false)
    }
  };

  const Settings = (card) => (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button className="bg-gray-100 text-gray-800 p-2 rounded-md">
          <BsThreeDotsVertical />
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          sideOffset={5}
          side="left"
          className="mt-[7rem] md:mt-[9.4rem] rounded-md px-1 py-3 flex flex-col border border-gray-300 bg-white shadow-md w-48"
        >
          <button onClick={() => { setisEditing(true) }} className="ps-3 py-2 w-full hidden md:flex text-start text-gray-700 hover:bg-gray-100 rounded-md">
            Edit
          </button>
          <AlertDialog.Root open={isEditing}>
            <AlertDialog.Portal>
              <AlertDialog.Overlay className="bg-main bg-opacity-70 data-[state=open]:animate-overlayShow fixed inset-0" />
              <AlertDialog.Content className="data-[state=open]:animate-slideDown fixed bottom-0 left-0 h-[94vh] w-full rounded-t-2xl bg-white shadow-md focus:outline-none">
                <button
                  onClick={() => { SortData(); setisEditing(false); }}
                  className="fixed top-1 rounded-md p-1 right-1"
                >
                  <IoCloseSharp className="text-xl rounded-full text-white" />
                </button>

                {card.type == "image" && <ImagePreviewCard setResults={setResults} setisEditing={setisEditing} HandleDelete={HandleDelete} isDeleting={isDeleting} item={card} />}
                {card.type == "sketch" && <DrawingPreviewCard setResults={setResults} setisEditing={setisEditing} HandleDelete={HandleDelete} isDeleting={isDeleting} item={card} />}
                {card.type == "todo" && <TodoPreviewCard setResults={setResults} SortData={SortData} setisEditing={setisEditing} HandleDelete={HandleDelete} isDeleting={isDeleting} item={card} />}
                {card.type == "note" && <NoteCardPreviewCard setResults={setResults} SortData={SortData} setisEditing={setisEditing} HandleDelete={HandleDelete} isDeleting={isDeleting} item={card} />}
              </AlertDialog.Content>
            </AlertDialog.Portal>
          </AlertDialog.Root>

          <button onClick={() => { setisRenameOpen(true) }} className="ps-3 py-2 w-full text-start text-gray-700 hover:bg-gray-100 rounded-md">
            Rename
          </button>
          <AlertDialog.Root open={isRenameOpen}>
            <AlertDialog.Portal>
              <AlertDialog.Overlay className="bg-black/30 fixed inset-0" />
              <AlertDialog.Content className=" fixed top-1/2 left-1/2 max-h-[85vh] w-[90vw] max-w-[400px] transform -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white p-6 shadow-lg focus:outline-none">
                <AlertDialog.Title className="text-gray-800 text-lg font-semibold">
                  Rename
                </AlertDialog.Title>
                <div className="my-4">
                  <input
                    type="text"
                    defaultValue={card.name}
                    onChange={(e) => setNewCardName(e.target.value)}
                    placeholder="Enter new name"
                    className="w-full border border-gray-300 focus:outline-none shadow-sm rounded-md p-2"
                  />
                </div>
                <div className="flex justify-end gap-3">
                  <button onClick={() => setisRenameOpen(false)} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">
                    Cancel
                  </button>
                  <button
                    onClick={() => handleCardRename(card)}
                    disabled={isRenaming}
                    className={`text-white bg-main hover:bg-main/80 disabled:bg-gray-400 px-4 py-2 rounded-md`}
                  >
                    Rename
                  </button>
                </div>
              </AlertDialog.Content>
            </AlertDialog.Portal>
          </AlertDialog.Root>

          <button onClick={() => { setisShareOpen(true) }} className="ps-3 py-2 w-full text-start text-gray-700 hover:bg-gray-100 rounded-md">
            Share
          </button>
          <AlertDialog.Root open={isShareOpen}>
            <AlertDialog.Portal>
              <AlertDialog.Overlay className="bg-black/30 fixed inset-0" />
              <AlertDialog.Content className="fixed top-1/2 left-1/2 max-h-[85vh] w-[90vw] max-w-[900px] transform -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white shadow-md focus:outline-none">
                <div className="md:flex">
                  <div className="md:w-2/5 bg-cover hidden rounded-s-md md:block" style={{ backgroundImage: "url('https://ik.imagekit.io/vituepzjm/business-card-mockup-designs_1263741-10414.jpg?updatedAt=1724522878953')" }}></div>
                  <div className="md:w-3/5 md:border-t-0 rounded-t-md border-t-8 border-main w-full p-6">
                    <div className="flex justify-end">
                      <button onClick={() => { setisShareOpen(false) }} ><IoClose className="text-xl text-gray-700" /></button>
                    </div>
                    <div className="pt-4 pb-12">
                      <h1 className="text-xl md:text-2xl font-semibold mb-2 text-gray-800">Share Your {card.type[0].toUpperCase() + card.type.slice(1)} Card</h1>
                      <p className="text-gray-500 mb-4 font-medium">You can share your {card.type} card with others, so they can access and edit it from the shared space.</p>
                      <form onSubmit={HandleShare} className="relative mt-6 mb-4">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                          <svg className="w-4 h-4 text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 16">
                            <path d="m10.036 8.278 9.258-7.79A1.979 1.979 0 0 0 18 0H2A1.987 1.987 0 0 0 .641.541l9.395 7.737Z" />
                            <path d="M11.241 9.817c-.36.275-.801.425-1.255.427-.428 0-.845-.138-1.187-.395L0 2.6V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2.5l-8.759 7.317Z" />
                          </svg>
                        </div>
                        <input type="email" onChange={(e) => setShare({ email: e.target.value, obj: card })} className="placeholder-gray-500 border border-gray-300 text-gray-700 text-sm rounded-lg focus:outline-none block w-full pl-10 p-2.5" placeholder="example@gmail.com" required />
                      </form>

                      <p className="text-sm ps-2 text-gray-600 font-medium">* Please enter the email address of the recipient to share this {card.type} card.</p>
                    </div>
                  </div>
                </div>
              </AlertDialog.Content>
            </AlertDialog.Portal>
          </AlertDialog.Root>

          <button onClick={() => setisDeleteOpen(true)} className="ps-3 py-2 w-full text-start text-red-600 hover:bg-red-50 rounded-md">Move to Trash</button>
          <AlertDialog.Root open={isDeleteOpen} >
            <AlertDialog.Portal>
              <AlertDialog.Overlay className="bg-black/30 fixed inset-0" />
              <AlertDialog.Content className="fixed top-1/2 left-1/2 max-h-[85vh] w-[90vw] max-w-[600px] transform -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white p-6 shadow-md focus:outline-none">
                <AlertDialog.Title className="text-red-600 text-xl font-semibold">
                  Are you absolutely sure?
                </AlertDialog.Title>
                <AlertDialog.Description className="text-gray-600 font-medium mt-2 mb-6">
                  This action cannot be undone. This will move <span className="font-bold text-main">{`${card.name} - ${card.type[0].toUpperCase() + card.type.slice(1) + ' Card'}`}</span> to Trash page you can restore at anytime.
                </AlertDialog.Description>
                <div className="flex justify-start gap-3">
                  <button disabled={isDeleting} onClick={() => HandleDelete(card)} className="px-4 py-2 bg-red-600 disabled:bg-red-400 text-white rounded-md hover:bg-red-700">
                    Move to Trash
                  </button>
                  <button onClick={() => setisDeleteOpen(false)} className="px-4 py-2 bg-main/10 text-main/90 rounded-md hover:bg-main/20">
                    Cancel
                  </button>
                </div>
              </AlertDialog.Content>
            </AlertDialog.Portal>
          </AlertDialog.Root>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );

  return (
    <div className="flex w-full h-full gap-3">
      <div className="bg-white h-full overflow-auto rounded-md shadow-md p-3 w-full border border-gray-300" >
        <div className="flex items-center mt-3 justify-between gap-5 ">
          <div className="ms-3 flex">
            <ul class="flex items-center gap-3">
              <li>
                {" "}
                <Link
                  to="/dashboard"
                  class="flex items-center gap-2 cursor-pointer group"
                >
                  <span class="font-medium text-base hover:underline underline-offset-2 leading-7 text-main/60">
                    Home
                  </span>
                </Link>
              </li>

              <li>
                <Link
                  to="/dashboard/noteboard"
                  class="flex items-center gap-2 cursor-pointer group"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="5"
                    height="20"
                    viewBox="0 0 5 20"
                    fill="none"
                  >
                    <path
                      d="M4.12567 1.13672L1 18.8633"
                      stroke="#1a1a1a60"
                      stroke-width="1.6"
                      stroke-linecap="round"
                    />
                  </svg>
                  <span class="font-medium hover:underline underline-offset-2 text-base leading-7 text-main/60">
                    NoteBoard
                  </span>
                </Link>
              </li>

              <li>
                <Link
                  to="/dashboard/noteboard/search"
                  class="flex items-center gap-2 cursor-pointer group"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="5"
                    height="20"
                    viewBox="0 0 5 20"
                    fill="none"
                  >
                    <path
                      d="M4.12567 1.13672L1 18.8633"
                      stroke="#1a1a1a60"
                      stroke-width="1.6"
                      stroke-linecap="round"
                    />
                  </svg>
                  <span class="font-semibold hover:underline underline-offset-2 text-base leading-7 text-main">
                    Search
                  </span>
                </Link>
              </li>
            </ul>
          </div>
          <span className="inline-flex items-center gap-5"></span>
        </div>
        <div className="flex items-center mt-5 md:mt-10 mb-5 justify-center">
          <div className="flex items-center w-full">
            <label for="simple-search" className="sr-only">Search</label>
            <div className="relative w-full">
              <input onChange={(e) => setInput(e.target.value)} type="text" id="simple-search" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-main focus:border-main block w-full pl-3 p-2.5 " placeholder="Search" />
            </div>
            <button type="submit" className="p-2.5 ml-2 text-sm font-medium text-white bg-main rounded-lg border border-main transition-all active:scale-95 focus:outline-none">
              <FaSearch className="text-[1rem]" />
            </button>

            <Popover.Root>
              <Popover.Trigger asChild>
                <button className="p-2.5 ml-2 text-sm font-medium text-white bg-main rounded-lg border border-main transition-all active:scale-95 focus:outline-none">
                  <FaFilter className="text-[1rem]" />
                </button>
              </Popover.Trigger>
              <Popover.Portal>
                <Popover.Content sideOffset={5} side="bottom" className=" z-[100] rounded-lg px-5 py-4 bg-white focus:outline-none border border-main/60 me-5 md:me-8 shadow-lg w-fit">
                  <div className="pb-3">
                    <h1 className="text-main mb-3">Colors</h1>
                    <div className={`grid gap-3 place-items-center ${availableColors.length > 5 ? "grid-cols-5" : "grid-cols-3"}`}>
                      <button
                        onClick={() => setColor('')}
                        className="p-2 bg-gray-100 text-gray-400 rounded-md border"
                      >
                        <PiEmptyBold />
                      </button>

                      {availableColors.map((item, index) => (
                        <button
                          key={index}
                          onClick={() => setColor(item)}
                          style={{ backgroundColor: item, borderColor: item === Color ? '#1a1a1a' : '' }}
                          className="w-8 h-8 rounded-md border"
                        />
                      ))}
                    </div>
                  </div>
                  <div className="pb-3">
                    <h1 className="text-main mb-3">Types</h1>
                    <div className={`grid gap-3 place-items-center ${availableColors.length > 5 ? "grid-cols-5" : "grid-cols-3"}`}>
                      <button
                        onClick={() => setType('')}
                        className="p-2 bg-gray-100 rounded-md border"
                      >
                        <PiEmptyBold />
                      </button>
                      {availableTypes.map((item, index) => (
                        <button
                          key={index}
                          className={`focus:outline-none ${item.name == Type ? 'text-main' : 'text-gray-400'}`}
                          onClick={() => setType(item.name)}
                          dangerouslySetInnerHTML={{ __html: item.svg }}
                        />
                      ))}

                    </div>
                  </div>
                  <Popover.Arrow className="fill-main/60" />
                </Popover.Content>
              </Popover.Portal>
            </Popover.Root>
          </div>
        </div>

        <div>
          {cards.length == 0 ?
            <div className="flex items-center justify-center w-full h-[60vh]">
              <div className="flex flex-col items-center justify-center">
                <img src="https://ik.imagekit.io/vituepzjm/undraw_no_data_re_kwbl.svg?updatedAt=1724617424362" alt="No data" className="size-36 mb-3" />
                <h1 className="md:text-3xl font-serif italic text-center break-words text-xl mb-2 text-main/30 dark:text-white">You Have Not Created any Cards Yet</h1>
              </div>
            </div> :
            <div className={`grid gap-5 w-full md:grid-cols-1 lg:grid-cols-2 sm:grid-cols-2 ${isNotEmptyObject(boardPreview) ? "xl:grid-cols-2" : "xl:grid-cols-3"}`}>
              {results.map((card, index) => (
                <div key={index} >
                  {card.type == "image" && <div
                    style={{ backgroundColor: card.color }} className="relative bg-white border hidden md:block shadow-sm rounded-md">
                    <img onClick={() => {
                      const selfCheck = boardPreview?.ncid === card.ncid;
                      setboardPreview(selfCheck ? {} : card);
                    }} className="w-full cursor-pointer brightness-95 h-[300px] object-cover rounded-md" src={card.data} alt={card.name} />
                    <div className="absolute top-3 start-3">
                      <h3 className="text-main px-2 py-1 bg-white rounded-md w-fit">
                        {card.name.length <= 10 ? card.name : `${card.name.slice(0, 10)}..`}
                      </h3>
                    </div>
                    <div className="absolute top-3 end-3">
                      {Settings(card)}
                    </div>
                    <div className="absolute bottom-3 start-3">
                      <h3 class="text-main px-2 text-sm py-1 bg-white rounded-md w-fit">
                        {ParseDate(card.updatedAt)}
                      </h3>
                    </div>
                  </div>}

                  {card.type === "note" && (
                    <div
                      style={{ backgroundColor: card.color }}
                      className="h-[300px] p-3 w-full hidden md:block border rounded-md shadow-sm"
                    >
                      <div className="w-full flex items-center justify-between">
                        <div className="w-fit px-2 py-1 rounded-md bg-white text-main">
                          {card.name.length <= 10 ? card.name : `${card.name.slice(0, 10)}..`}
                        </div>
                        {Settings(card)}
                      </div>

                      <div onClick={() => {
                        const selfCheck = boardPreview?.ncid === card.ncid;
                        setboardPreview(selfCheck ? {} : card);
                      }} className="h-[200px] overflow-y-auto cursor-pointer my-2 mx-2">
                        <div dangerouslySetInnerHTML={{ __html: generateHTML(card.data) }} />
                      </div>

                      <div className="w-fit bottom-3 left-3 px-2 py-1 text-sm rounded-md bg-white text-main">
                        {ParseDate(card.updatedAt)}
                      </div>
                    </div>
                  )}
                  {card.type === "todo" && (
                    <div
                      style={{ backgroundColor: card.color }}
                      className="h-[300px] p-3 w-full border hidden md:block rounded-md shadow-sm"
                    >
                      <div className="w-full flex items-center justify-between">
                        <div className="w-fit px-2 py-1 rounded-md bg-white text-main">
                          {card.name.length <= 10 ? card.name : `${card.name.slice(0, 10)}..`}
                        </div>
                        {Settings(card)}
                      </div>

                      <div onClick={() => {
                        const selfCheck = boardPreview?.ncid === card.ncid;
                        setboardPreview(selfCheck ? {} : card);
                      }} className="h-[200px] overflow-y-auto cursor-pointer my-2 mx-2">
                        <div dangerouslySetInnerHTML={{ __html: generateHTML(card.data) }} />
                      </div>

                      <div className="w-fit bottom-3 left-3 px-2 py-1 text-sm rounded-md bg-white text-main">
                        {ParseDate(card.updatedAt)}
                      </div>
                    </div>
                  )}
                  {card.type === "sketch" && (
                    <div
                      style={{ backgroundColor: card.color }}
                      className="h-[300px] p-3 w-full border hidden md:block rounded-md shadow-sm"
                    >
                      <div className="flex w-full items-center justify-between" >
                        <div className="w-fit top-3 left-3 px-2 py-1 rounded-md bg-white text-main">
                          {card.name.length <= 10 ? card.name : `${card.name.slice(0, 10)}..`}
                        </div>
                        <div className=" top-3 end-3">
                          {Settings(card)}
                        </div>
                      </div>

                      <div onClick={() => {
                        const selfCheck = boardPreview?.ncid === card.ncid;
                        setboardPreview(selfCheck ? {} : card);
                      }} className="cursor-pointer z-[100] my-2">
                        <div className="w-full h-[200px]" dangerouslySetInnerHTML={{ __html: card?.data }} />
                      </div>


                      <div className="w-fit bottom-3 left-3 px-2 py-1 text-sm rounded-md bg-white text-main">
                        {ParseDate(card.updatedAt)}
                      </div>
                    </div>
                  )}
                  {/* {card.type == "audio" && <div

                    style={{ backgroundColor: card.color }}
                    className="h-[300px] p-3 w-full border rounded-md shadow-sm"
                  >
                    <div className="w-full flex items-center justify-between">
                      <div className="w-fit px-2 py-1 rounded-md bg-white text-main">
                        {card.name.length <= 10 ? card.name : `${card.name.slice(0, 10)}..`}
                      </div>
                      {Settings(card)}
                    </div>

                    <div onClick={() => {
                      const selfCheck = boardPreview?.ncid === card.ncid;
                      setboardPreview(selfCheck ? {} : card);
                    }} className="h-[200px] my-2 flex items-center justify-center p-4">
                      <MdOutlinePlayCircleFilled className="text-8xl text-white border-dashed border-[3px] border-white rounded-full" />
                    </div>

                    <div className="w-fit bottom-3 left-3 px-2 py-1 text-sm rounded-md bg-white text-main">
                      {ParseDate(card.updatedAt)}
                    </div>
                  </div>} */}

                  {card.type == "image" && <div
                    style={{ backgroundColor: card.color }} className="relative bg-white border md:hidden shadow-sm rounded-md">
                    <img onClick={() => {
                      setboardPreview(card);
                      setisBoardEditing(true);
                      SortData();
                    }} className="w-full cursor-pointer brightness-95 h-[300px] object-cover rounded-md" src={card.data} alt={card.name} />
                    <div className="absolute top-3 start-3">
                      <h3 className="text-main px-2 py-1 bg-white rounded-md w-fit">
                        {card.name.length <= 10 ? card.name : `${card.name.slice(0, 10)}..`}
                      </h3>
                    </div>
                    <div className="absolute top-3 end-3">
                      {Settings(card)}
                    </div>
                    <div className="absolute bottom-3 start-3">
                      <h3 class="text-main px-2 text-sm py-1 bg-white rounded-md w-fit">
                        {ParseDate(card.updatedAt)}
                      </h3>
                    </div>
                  </div>}
                  {card.type === "note" && (
                    <div
                      style={{ backgroundColor: card.color }}
                      className="h-[300px] p-3 w-full border md:hidden rounded-md shadow-sm"
                    >
                      <div className="w-full flex items-center justify-between">
                        <div className="w-fit px-2 py-1 rounded-md bg-white text-main">
                          {card.name.length <= 10 ? card.name : `${card.name.slice(0, 10)}..`}
                        </div>
                        {Settings(card)}
                      </div>

                      <div onClick={() => {
                        setboardPreview(card);
                        setisBoardEditing(true);
                        SortData();
                      }} className="h-[200px] overflow-y-auto cursor-pointer my-2 mx-2">
                        <div dangerouslySetInnerHTML={{ __html: generateHTML(card.data) }} />
                      </div>

                      <div className="w-fit bottom-3 left-3 px-2 py-1 text-sm rounded-md bg-white text-main">
                        {ParseDate(card.updatedAt)}
                      </div>
                    </div>
                  )}
                  {card.type === "todo" && (
                    <div
                      style={{ backgroundColor: card.color }}
                      className="h-[300px] p-3 w-full border md:hidden rounded-md shadow-sm"
                    >
                      <div className="w-full flex items-center justify-between">
                        <div className="w-fit px-2 py-1 rounded-md bg-white text-main">
                          {card.name.length <= 10 ? card.name : `${card.name.slice(0, 10)}..`}
                        </div>
                        {Settings(card)}
                      </div>

                      <div onClick={() => {
                        setboardPreview(card);
                        setisBoardEditing(true);
                        SortData();
                      }} className="h-[200px] overflow-y-auto cursor-pointer my-2 mx-2">
                        <div dangerouslySetInnerHTML={{ __html: generateHTML(card.data) }} />
                      </div>

                      <div className="w-fit bottom-3 left-3 px-2 py-1 text-sm rounded-md bg-white text-main">
                        {ParseDate(card.updatedAt)}
                      </div>
                    </div>
                  )}
                  {card.type === "sketch" && (
                    <div
                      style={{ backgroundColor: card.color }}
                      className="h-[300px] p-3 w-full border md:hidden rounded-md shadow-sm"
                    >
                      <div className="flex w-full items-center justify-between" >
                        <div className="w-fit top-3 left-3 px-2 py-1 rounded-md bg-white text-main">
                          {card.name.length <= 10 ? card.name : `${card.name.slice(0, 10)}..`}
                        </div>
                        <div className=" top-3 end-3">
                          {Settings(card)}
                        </div>
                      </div>

                      <div onClick={() => {
                        setboardPreview(card);
                        setisBoardEditing(true);
                        SortData();
                      }} className="cursor-pointer z-[100] my-2">
                        <div className="w-full h-[200px]" dangerouslySetInnerHTML={{ __html: card?.data }} />
                      </div>


                      <div className="w-fit bottom-3 left-3 px-2 py-1 text-sm rounded-md bg-white text-main">
                        {ParseDate(card.updatedAt)}
                      </div>
                    </div>
                  )}

                </div>
              ))}
            </div>
          }
        </div>
      </div>

      {isNotEmptyObject(boardPreview) && (
        <div className="bg-white rounded-md shadow-md xl:block hidden w-[450px] border border-gray-300">
          <div className="flex p-3 rounded-t-md items-center justify-between bg-main text-white">
            <p className="text-lg font-medium">Card Preview</p>
            <span className="inline-flex items-center gap-2">
              <button onClick={() => { setisBoardEditing(true) }} >
                <FaEdit />
              </button>

              <AlertDialog.Root open={isBoardEditing}>
                <AlertDialog.Portal>
                  <AlertDialog.Overlay className="bg-main bg-opacity-70 data-[state=open]:animate-overlayShow fixed inset-0" />
                  <AlertDialog.Content className="data-[state=open]:animate-slideDown fixed bottom-0 left-0 h-[94vh] w-full rounded-t-2xl bg-white shadow-md focus:outline-none">
                    <button
                      onClick={() => { SortData(); setisBoardEditing(false); }}
                      className="fixed top-1 rounded-md p-1 right-1"
                    >
                      <IoCloseSharp className="text-xl rounded-full text-white" />
                    </button>

                    {boardPreview.type == "image" && <ImagePreviewCard setResults={setResults} setisEditing={setisEditing} HandleDelete={HandleDelete} isDeleting={isDeleting} item={boardPreview} />}
                    {boardPreview.type == "sketch" && <DrawingPreviewCard setResults={setResults} setisEditing={setisEditing} HandleDelete={HandleDelete} isDeleting={isDeleting} item={boardPreview} />}
                    {boardPreview.type == "todo" && <TodoPreviewCard setResults={setResults} SortData={SortData} setisEditing={setisEditing} HandleDelete={HandleDelete} isDeleting={isDeleting} item={boardPreview} />}
                    {boardPreview.type == "note" && <NoteCardPreviewCard setResults={setResults} SortData={SortData} setisEditing={setisEditing} HandleDelete={HandleDelete} isDeleting={isDeleting} item={boardPreview} />}
                  </AlertDialog.Content>
                </AlertDialog.Portal>
              </AlertDialog.Root>
              <button
                onClick={() => setboardPreview({})}
                className="text-white active:scale-90 p-2 rounded-lg transition-all ease-linear"
              >
                <FaCompressAlt />
              </button>
            </span>
          </div>
          <div className="p-3 overflow-y-auto h-[75vh]">
            {isNotEmptyObject(boardPreview) ? <Card item={boardPreview} /> : <div>No Card Selected</div>}
          </div>
        </div>
      )}

      <Toaster />

    </div>
  );
}

export default Search;
